// extracted by mini-css-extract-plugin
export var paginationContainer = "Pagination-module--paginationContainer--FOZcH";
export var pagination = "Pagination-module--pagination--w3ecF";
export var selectedButton = "Pagination-module--selectedButton--0+09L";